import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Calculator, BarChart3, FileText, Menu, X, Search, PieChart } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isAdmin = location.pathname === '/admin';
  if (isAdmin) return null;

  const links = [
    { to: "/", label: "Calculator", icon: Calculator },
    { to: "/compare", label: "Compare", icon: BarChart3 },
    { to: "/search-city", label: "Search City", icon: Search },
    { to: "/budget-planner", label: "Budget", icon: PieChart },
    { to: "/blog", label: "Blog", icon: FileText },
  ];

  return (
    <header className="glass-header sticky top-0 z-50" data-testid="navbar" role="navigation" aria-label="Main navigation">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-white focus:rounded-lg focus:text-sm">Skip to content</a>
      <div className="container-main flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 no-underline" data-testid="navbar-logo">
          <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
            <span className="text-white font-bold text-sm">A</span>
          </div>
          <span className="text-xl font-bold text-slate-900 tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Afford<span className="text-emerald-600">Scope</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1" data-testid="navbar-desktop-nav">
          {links.map(l => (
            <Link key={l.to} to={l.to} data-testid={`nav-link-${l.label.toLowerCase()}`}>
              <Button variant={location.pathname === l.to ? "secondary" : "ghost"} size="sm" className="gap-2 text-slate-600 hover:text-slate-900">
                <l.icon className="w-4 h-4" />
                {l.label}
              </Button>
            </Link>
          ))}
        </nav>

        <button className="md:hidden p-2 text-slate-600" onClick={() => setOpen(!open)} data-testid="navbar-mobile-toggle">
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-100 bg-white p-4 space-y-1" data-testid="navbar-mobile-menu">
          {links.map(l => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
              className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-600 hover:bg-slate-50 hover:text-slate-900 no-underline">
              <l.icon className="w-4 h-4" />
              <span className="text-sm font-medium">{l.label}</span>
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}
